// extracted by mini-css-extract-plugin
module.exports = {"input":"inputWTN_input__1hAWZ","error":"inputWTN_error__a4jNr","scaleToSize":"inputWTN_scaleToSize__24yQC","fadeIn":"inputWTN_fadeIn__2WPKM","fadeOut":"inputWTN_fadeOut__2Y0X5"};